import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBurger: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBurger"><Path d="M6.13554 4.67307C7.92408 3.43463 10.1515 3 12 3C13.8485 3 16.0759 3.43463 17.8645 4.67308C19.692 5.93854 21 8.00504 21 11.0938V11.5H3V11.0938C3 8.00504 4.30798 5.93854 6.13554 4.67307Z" fill="currentColor"/><Path d="M21 21V16.5H3V21H21Z" fill="currentColor"/><Path d="M22 15V13H2V15H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBurger;
